import './eunpyeongcare-notice-modal.css';

export default function EunpyeongCareNoticeModal({
  title,
  message,
  onConfirm,
}: {
  title: string;
  message?: string;
  onConfirm: () => void;
}) {
  return (
    <div className="eunpyeongcare-notice-modal" role="presentation">
      <div className="eunpyeongcare-notice-modal__card" role="dialog" aria-modal="true" aria-labelledby="ep-notice-title">
        <div className="eunpyeongcare-notice-modal__header">
          <p id="ep-notice-title" className="eunpyeongcare-notice-modal__title">
            {title}
          </p>
          {message ? <p className="eunpyeongcare-notice-modal__body">{message}</p> : null}
        </div>
        <div className="eunpyeongcare-notice-modal__bottom">
          <button type="button" className="eunpyeongcare-notice-modal__btn" onClick={onConfirm}>
            확인
          </button>
        </div>
      </div>
    </div>
  );
}
